import React from 'react';
import styled from 'styled-components';
import { Icon, IconLookup } from '../../../Atoms/Icon';
import { getOptionLabel } from '../utils';
const StyledContainer = styled.div `
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  font-weight: 700;
`;
const StyledInnerContainer = styled.div `
  margin-right: 1rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
const StyledPlaceholder = styled.span `
  user-select: none;
`;
const StyledIcon = styled(Icon) `
  font-weight: 700;
`;
const renderContent = (selectedOptions, selectedOptionSeparator, placeholder, allSelected, allSelectedLabel) => {
    let content = null;
    if (allSelectedLabel && allSelected) {
        content = allSelectedLabel;
    }
    else if (!selectedOptions.length) {
        content = placeholder;
    }
    else {
        content = selectedOptions.map(getOptionLabel).join(selectedOptionSeparator);
    }
    return (React.createElement(StyledInnerContainer, { title: content },
        React.createElement(StyledPlaceholder, null, content)));
};
const SelectedOptionDisplayer = ({ className, iconClassName, placeholder, allSelected, allSelectedLabel, selectedOptions, selectedOptionSeparator, }) => (React.createElement(StyledContainer, { className: className },
    renderContent(selectedOptions, selectedOptionSeparator, placeholder, allSelected, allSelectedLabel),
    React.createElement(StyledIcon, { className: iconClassName, icon: IconLookup.CHEVRON_DOWN })));
export default SelectedOptionDisplayer;
